import React from "react";
import { Link } from "react-router-dom";
import { Carousel, Image } from "react-bootstrap";
import Message from "./Message";
import { useGetTopProductsQuery } from "../slices/productsApiSlice";

const ProductCarousel = () => {
  const { data: products, isLoading, error } = useGetTopProductsQuery();

  return isLoading ? null : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <Carousel pause="hover" className="bg-primary mb-4">
      {products.map((product) => (
        <Carousel.Item key={product._id} style={{ textAlign: "center" }}>
          <Link to={`/product/${product._id}`}>
            <Image
              src={product.image1}
              alt={product.name}
              fluid
              style={{ maxWidth: "100%", maxHeight: "600px" }} // Adjust these values accordingly
            />
            <Carousel.Caption className="carousel-caption">
              <h2 className="text-white">
                {product.name} (${product.price})
              </h2>
            </Carousel.Caption>
          </Link>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default ProductCarousel;
